import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective implements AfterViewInit {

  constructor(
    private readonly _elementRef: ElementRef
  ) { }

  ngAfterViewInit(): void {
    this._elementRef.nativeElement.focus();
  }

}
